import { render, staticRenderFns } from "./new-orders-table.component.vue?vue&type=template&id=6cb17c9e&scoped=true"
import script from "./new-orders-table.component.vue?vue&type=script&lang=js"
export * from "./new-orders-table.component.vue?vue&type=script&lang=js"
import style0 from "./new-orders-table.component.vue?vue&type=style&index=0&id=6cb17c9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb17c9e",
  null
  
)

export default component.exports